import { useCallback, useState } from "react";
import { confirmTariffPayment } from "../../api/user";
import { useTariffRequestList } from "../../hooks/useTariffRequestList";
import { Shimmer } from "../Shimmer/Shimmer";
import { useNotification } from "../Notification/NotificationProvider";
import { TariffRequestsTable } from "../TariffRequestsTable/TariffRequestsTable";
import "../RequestsSection/RequestsSection.scss";

export const TariffRequestsSection = () => {
  const { showNotification } = useNotification();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [confirmingPayId, setConfirmingPayId] = useState<string | null>(null);
  const { data, totalPages, loading, error, refetch, removeByPayId } = useTariffRequestList({
    page,
    pageSize,
  });

  const handleConfirm = useCallback(
    (payId: string) => {
      setConfirmingPayId(payId);
      confirmTariffPayment(payId)
        .then(() => {
          removeByPayId(payId);
          showNotification({
            message: "Оплата тарифа подтверждена",
            variant: "success",
          });
          refetch();
        })
        .catch(() => undefined)
        .finally(() => {
          setConfirmingPayId(null);
        });
    },
    [refetch, removeByPayId, showNotification]
  );

  return (
    <section className="requests-section requests-section--embedded" aria-label="Запросы на тарифы">
      <div className="requests-section-header">
        <h1 className="requests-section-title">Запросы</h1>
      </div>

      {loading ? (
        <Shimmer rows={5} />
      ) : error ? (
        <div className="requests-section-error">
          <p className="requests-section-error__text">{error}</p>
          <button type="button" className="requests-section-error__retry" onClick={refetch}>
            Повторить
          </button>
        </div>
      ) : (
        <TariffRequestsTable
          data={data}
          page={page}
          pageSize={pageSize}
          totalPages={totalPages}
          confirmingPayId={confirmingPayId}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          onConfirm={handleConfirm}
        />
      )}
    </section>
  );
};
